import { render, staticRenderFns } from "./case-party-card.vue?vue&type=template&id=52aae721&scoped=true&"
import script from "./case-party-card.vue?vue&type=script&lang=js&"
export * from "./case-party-card.vue?vue&type=script&lang=js&"
import style0 from "./case-party-card.vue?vue&type=style&index=0&id=52aae721&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52aae721",
  null
  
)

export default component.exports